import { useCommunityDetail } from '@communities/community/hooks';

/**
 * Adapter hook for accessing selected community data from the core domain
 * This provides a core-specific interface to the communities state and data
 * Consider using dependency injection pattern or event-driven architecture
 * to maintain proper domain separation when splitting into separate repos
 * @returns An object containing the community details
 */
export function useSelectedCommunity() {
  // Fetch community details using the URL-based approach
  const { community } = useCommunityDetail();

  return {
    community,
  };
}
